import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { forkJoin, Subject } from "rxjs";
import { Agent, AgentClient, AgentService, AgentServicesClient, DeliverService, DeliverServicesClient, DocumentClient, Documents, DocumentServices, DocumentTypeClient, DocumentTypes, Material, MaterialClient, NServices, ServiceClient, Unit, VIKUnitClient } from "src/app/web-api-client";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-materials-edit',
  templateUrl: './materials-edit.component.html',
  styleUrls: ['./materials-edit.component.scss']
})
export class MaterialEditComponent implements OnInit {

  public isLoaded = false;
  public editObject: Material;  
  public units: Unit[] = []; 
  public onClose = new Subject<boolean>();

  Form: FormGroup;

  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal, public client: MaterialClient, public unitClients: VIKUnitClient) { }

  ngOnInit(): void { 
    this.unitClients.getList().subscribe(d => {

      this.units = d;
      this.initializeForm();
      this.isLoaded = true;
    });

    

  }

  initializeForm() {
    this.Form = this.fb.group({
      title: [this.editObject.title, Validators.required],
      description: [this.editObject.description, Validators.required],
      unitId: [this.editObject.unitId, Validators.required],
      pricePerUnit: [this.editObject.pricePerUnit, Validators.required],
      totalQuantity: [this.editObject.totalQuantity, Validators.required],
      isActive: [this.editObject.isActive, Validators.required]
    });
  }
  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }
  onSubmit() {
    if (this.Form.valid) {

      this.editObject.title = this.Form.value.title;
      this.editObject.description = this.Form.value.description;
      this.editObject.unitId = this.Form.value.unitId;
      this.editObject.pricePerUnit = this.Form.value.pricePerUnit;
      this.editObject.totalQuantity = this.Form.value.totalQuantity; 
      this.editObject.isActive = this.Form.value.isActive;



      this.client.update(this.editObject).subscribe((user) => {

        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

  public isSelected(service:Material) {
    let result = this.editObject.id == service.id;
    return result;
  }
  

}
